"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const types_1 = require("../loading/types");
const actionCreators = __importStar(require("./actions"));
const initialState = {
    isLoading: types_1.LOADING_STATE.LOADING,
    user: null,
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    var _a;
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.setUserDataAction):
        case (0, typesafe_actions_1.getType)(actionCreators.deleteUser): {
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setUserDataSuccess): {
            draft.isLoading = types_1.LOADING_STATE.COMPLETE;
            draft.user = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setDeleteUserSuccess): {
            draft.isLoading = types_1.LOADING_STATE.COMPLETE;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setUserAddressSuccess): {
            if (action.payload.userId === ((_a = draft.user) === null || _a === void 0 ? void 0 : _a.id)) {
                draft.user.shippingAddresses = [action.payload, ...draft.user.shippingAddresses];
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.responseErrors): {
            draft.errors = action.payload.length === 0 ? undefined : action.payload;
            // eslint-disable-next-line no-useless-return
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setUserDiscounts): {
            draft.discounts = action.payload.length === 0 ? undefined : action.payload;
            break;
        }
        default:
            break;
    }
});
exports.default = reducer;
